import { ToastProgrammatic as Toast, NotificationProgrammatic as Notification } from 'buefy'

export default new class NotificationService {
  warning (message) {
    Toast.open({
      duration: 5000,
      message: message,
      position: 'is-bottom',
      type: 'is-danger'
    })
  }
  message (message) {
    Toast.open({
      duration: 5000,
      message: message,
      position: 'is-bottom'
    })
  }
  messageIndefinite (message) {
    return Notification.open({
      indefinite: true,
      hasIcon: true,
      message: message,
      type: 'is-white',
      position: 'is-bottom'
    })
  }

  close (notificationBox) {
    if (notificationBox) {
      notificationBox.close()
    }
  };
}()
